import Decimal from 'decimal.js';
import { VatRate } from './vat-rate';

export class InvoiceLineItem {

    constructor(
        public netAmount: Decimal,
        public vatRate: VatRate,
        public description: string,
        public id?: number
    ){}
}